import type { Step } from "react-joyride";

export const kpiOverviewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າພາບລວມ KPI! ຫນ້ານີ້ຈະສະແດງພາບລວມຂອງ KPI ທັງໝົດຕາມລະດັບຕ່າງໆ (ອົງກອນ, ພະແນກກ, ພະນັກງານ). ທ່ານສາມາດເບິ່ງສະຖິຕິ, ອັດຕາຜ່ານ, ແລະຜົນການປະເມີນຂອງ KPI ໃນໄລຍະເວລາທີ່ກຳນົດ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="overview-period-filter"]',
    content:
      "ນີ້ແມ່ນຕົວກອງໄລຍະເວລາ. ທ່ານສາມາດເລືອກເບິ່ງພາບລວມ KPI ຕາມເດືອນ ຫຼືໄຕມາດ, ເລືອກປີ, ແລະເລືອກເດືອນ/ໄຕມາດທີ່ຕ້ອງການ. ຂໍ້ມູນທັງໝົດຈະຖືກອັບເດດຕາມໄລຍະເວລາທີ່ເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="overview-summary-cards"]',
    content:
      "ນີ້ແມ່ນບັດສະຖິຕິພາບລວມ. ທ່ານຈະເຫັນຈຳນວນ KPI ທັງໝົດ, ຈຳນວນທີ່ຜ່ານ, ຈຳນວນທີ່ຕໍ່າກວ່າເປົ້າໝາຍ, ແລະອັດຕາຜ່ານ (pass rate) ຂອງອົງກອນ. ບັດເຫຼົ່ານີ້ຈະຊ່ວຍໃຫ້ທ່ານເຂົ້າໃຈພາບລວມຂອງ KPI ໄດ້ຢ່າງໄວ.",
    placement: "top",
  },
  {
    target: '[data-tourid="overview-organization-kpis"]',
    content:
      "ນີ້ແມ່ນພາກ KPI ອົງກອນ. ທ່ານຈະເຫັນບັດ KPI ທັງໝົດທີ່ຖືກມອບໝາຍໃຫ້ກັບລະດັບອົງກອນ. ແຕ່ລະບັດຈະສະແດງຊື່ KPI, ຄ່າຈິງ, ເປົ້າໝາຍ, ສະຖານະ (ຜ່ານ/ຕໍ່າກວ່າເປົ້າໝາຍ), ແລະອັດຕາສ່ວນຜ່ານ. ກົດບັດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມ.",
    placement: "top",
  },
  {
    target: '[data-tourid="overview-department-kpis"]',
    content:
      "ນີ້ແມ່ນພາກ KPI ຕາມພະແນກ. ທ່ານຈະເຫັນສະຖິຕິແລະ KPI ຂອງແຕ່ລະພະແນກ. ສຳລັບແຕ່ລະພະແນກ, ທ່ານຈະເຫັນຈຳນວນ KPI ທີ່ຜ່ານ, ຕໍ່າກວ່າເປົ້າໝາຍ, ແລະອັດຕາຜ່ານ. ທ່ານຍັງສາມາດເບິ່ງບັດ KPI ຂອງແຕ່ລະພະແນກໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="overview-employee-kpis"]',
    content:
      "ນີ້ແມ່ນພາກ KPI ພະນັກງານ. ທ່ານຈະເຫັນສະຖິຕິລວມຂອງ KPI ທຸກຕົວທີ່ມີລະດັບພະນັກງານ. ບັດສະຖິຕິຈະສະແດງຄ່າເຊື່ອມສະເລ່ຍ, ຈຳນວນທັງໝົດ, ຈຳນວນທີ່ຜ່ານ, ແລະຈຳນວນທີ່ຕໍ່າກວ່າເປົ້າໝາຍ.",
    placement: "top",
  },
];
